// src/App.tsx
import React from 'react';
import EthereumAddress from './EthereumAddress';

function App() {
  return (
    <div className="App">
      <EthereumAddress />
    </div>
  );
}

export default App;

